import { AnyAction, isType } from 'typescript-fsa';
import { CacheView } from '../../../services/betting';
import { cacheSet, cacheSetAvailable } from './actions';

interface CacheServerState {
    caches: CacheView[];
    serverAvailable: boolean;
}

export interface CacheState {
    [serverName: string]: CacheServerState;
}

const initialCacheState: CacheState = {
    
};

export function cacheReducer(state: CacheState = initialCacheState, action: AnyAction) {

    if (isType(action, cacheSet)) {
        const serverName = action.payload.serverName;
        const serverState: CacheServerState = { caches: action.payload.caches, serverAvailable: true };
        return {...state, [serverName]: serverState};
    } else if(isType(action, cacheSetAvailable)) {
        const serverName = action.payload.serverName;
        const serverState: CacheServerState = { caches: [], serverAvailable: action.payload.available };
        return {...state, [serverName]: serverState};
    }
    return state;
}